module.exports = __webpack_public_path__ + "static/media/logo-powered-by-stripe.64f7c20b.svg";